<template>
  <div>
    <div class="p-5 bg-white border-2 border-b-0 rounded-t gap-2">
      <v-row class="bg-whit">
        <v-col cols="12" class="text-center">{{ $t('task.approve_list_setting_history') }}</v-col>
      </v-row>
      <v-row class="bg-whit">
        <v-col cols="10">
          <v-row>
            <v-col cols="6">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="$helper.datelabel(startDate)"
                    :placeholder="$t('date')"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :label="$t('from_date')">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  locale="th"
                  @input="menu1 = false"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat" 
                  :weekday-format="$helper.formatWeekday"
                  :month-format="$helper.formatMonth">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="$helper.datelabel(endDate)"
                    :placeholder="$t('date')"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :label="$t('to_date')">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  locale="th"
                  @input="menu2 = false"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday"
                  :month-format="$helper.formatMonth">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="text-center">
          <v-btn
            @click="onSearch()"
            class="primary"
            block
            :disabled="isLoading || loading"
          >
            <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <template>
      <v-data-table
        :headers="headers"
        :items="approveTaskSettingHistory"
        :loading="loading || isLoading"
        :items-per-page="10"
        class="border-2 data-table-approvetask"
        item-key="objectId"
        :no-data-text="$t('task.no_approve_list_setting_history')"
        :no-results-text="$t('no_matching_records_found')"
      >
        <template v-slot:header.note="{ header }">
          <div class="text-nowrap-table text-center" style="min-width: 200px;">{{ header.text }}</div>
        </template>
        <template v-slot:item.areas="{ item }">{{ item.settingTaskAreaCount }} {{ $t('area.space') }}</template>
        <template v-slot:item.settingTaskSum.previous="{ item }">
          <div class="text-end text-no-wrap">
            {{ item.settingTaskSum.previous | currencyPrefixSign(item.currencyCode) }}
          </div>
        </template>
        <template v-slot:item.settingTaskSum.current="{ item }">
          <div class="text-end text-no-wrap">
            {{ item.settingTaskSum.current | currencyPrefixSign(item.currencyCode) }}
          </div>
        </template>
        <template v-slot:item.settingTaskSum="{ item }">
          <div class="text-end text-no-wrap d-inline-block" :class="item.settingTaskSum.class">{{ item.settingTaskSum.diffText | currencyPrefixSign(item.currencyCode,{ mathType: 'outSide' })}}</div>
        </template>>
        <template v-slot:item.createdBy="{ item }">{{ item.createdByFullName }}</template>
        <template v-slot:item.createdAt="{ item }">{{ item.createdAtDateFormat }}</template>
        <template v-slot:item.updatedBy="{ item }">{{ item.updatedByFullName }}</template>
        <template v-slot:item.updatedAt="{ item }">{{ item.updatedAtDateFormat }}</template>
        <template v-slot:item.status="{ item }">
          <div class="max-w-sm flex" style="justify-content: center;">
            <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
              {{
                item.statusString
              }}
            </span>
          </div>
        </template>
        <template v-slot:item.note="{ item }">
          <div class="text-truncate" style="text-align:left;">{{ item.cancelledNote || '-' }}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey lighten-4"
              elevation="0"
              rounded
              small
              @click="onClickDetail(item)"
            >{{ $t('detail') }}
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="isDetail" persistent>
      <v-card flat outlined :loading="isLoading" min-height="30">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="d-flex justify-space-between" style="width: 100%">
            <span>{{ $t('setting_detail') }}</span>
            <div>
              <v-btn
                @click="exportSettingTask()"
                class="blue white--text"
                :disabled="loading"
                style="margin-right:15px;"
              >
                <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
              </v-btn>
              <v-btn
                color="black"
                icon
                @click="isDetail = false; currentApproveTask = null"
                :disabled="isLoading"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding:0;">
          <v-data-table
            :loading="isLoading"
            :headers="settingTaskHeaders"
            :items-per-page="50"
            :items="currentSettingTasks"
            class="border-2 data-table-approvetask"
            sort-by="contractId"
            item-key="objectId"
            :no-data-text="$t('noinfo')"
            :no-results-text="$t('no_matching_records_found')"
          >
            <template v-slot:header.note="{ header }">
              <div class="text-nowrap-table" style="min-width: 200px;">{{ header.text }}</div>
            </template>
            <template v-slot:item.name="{ item }">{{ item.area.name }}</template>
            <template v-slot:item.action="{ item }">{{ item.actionString }} ({{ item.typeName }})</template>
            <template v-slot:item.previousPrice="{ item }">
              <div class="text-end text-no-wrap">
                {{ item.previousPrice | currencyPrefixSign(item.currencyCode) }}
              </div>
            </template>
            <template v-slot:item.currentPrice="{ item }">
              <div class="text-end text-no-wrap">
                {{ item.currentPrice | currencyPrefixSign(item.currencyCode) }}
              </div>
            </template>
            <template v-slot:item.previousOriginalDiscount="{ item }">
              <div class="text-end text-no-wrap">
                {{ item.previousOriginalDiscount | currencyPrefixSign(item.currencyCode) }}
              </div>
            </template>
            <template v-slot:item.currentOriginalDiscount="{ item }">
              <div class="text-end text-no-wrap">
                {{ item.currentOriginalDiscount | currencyPrefixSign(item.currencyCode) }}
              </div>
            </template>
            <template v-slot:item.diffPrice="{ item }">
              <div class="text-end text-no-wrap d-inline-block" :class="item.diffPrice.class">{{ item.diffPrice.text | currencyPrefixSign(item.currencyCode,{ mathType: 'outSide' })}}</div>
            </template>

            <template v-slot:item.createdBy="{ item }">{{ item.createdByFullName }}</template>
            <template v-slot:item.createdAt="{ item }">{{ item.createdAtDateFormat }}</template>
            <template v-slot:item.updatedBy="{ item }">{{ item.updatedByFullName }}</template>
            <template v-slot:item.updatedAt="{ item }">{{ item.updatedAtDateFormat }}</template>
            <template v-slot:item.status="{ item }">{{ item.statusString }}</template>
            <template v-slot:item.note="{ item }">
              <div class="text-truncate" style="text-align:left;">{{ item.cancelledNote || '-' }}</div>
            </template>
            <template v-slot:item.description="{ item }">
              <div style="text-align:left;">{{ item.description || '-' }}</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { ExportSettingTask } from "../exports";
import Approve from "./Approve.vue";
import { mapGetters } from "vuex";
export default {
  components: { Approve },
  data() {
    return {
      startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      menu1: false,
      menu2: false,
      isInterest: false,
      interestId: null,
      approveId: null,
      isConfirm: false,
      isApprove: false,
      isCancel: false,
      isDetail: false,
      currentSettingTasks: [],
      currentApproveTask: null,
      headers: [],
      settingTaskHeaders: [],
      items: [],
      selected: [],
      isLoading: false
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.headers = [
      {
        text: this.$t('area.number_of_market_area'),
        align: "center",
        sortable: false,
        value: "areas",
        width: "110px"
      },
      // {
      //   text: "จำนวนการดำเนินการ",
      //   align: "center",
      //   sortable: false,
      //   value: "taskActions"
      // },
      {
        sortable: false,
        text: this.$t('payment.total_amount_before'),
        align: "center",
        value: "settingTaskSum.previous",
        width: "110px"
      },
      {
        sortable: false,
        text: this.$t('payment.total_amount_after'),
        align: "center",
        value: "settingTaskSum.current",
        width: "110px"
      },
      {
        sortable: false,
        text: "",
        align: "center",
        value: "settingTaskSum"
      },
      {
        align: "center",
        value: "createdBy",
        text: this.$t('created_by')
      },
      {
        align: "center",
        value: "createdAt",
        text: this.$t('created_at')
      },
      {
        align: "center",
        value: "updatedBy",
        text: this.$t('change_status_by')
      },
      {
        align: "center",
        value: "updatedAt",
        text: this.$t('change_status_at')
      },
      {
        width: "120px",
        text: this.$t('status'),
        align: "center",
        sortable: false,
        value: "status"
      },
      {
        text: this.$t('note'),
        width: "200px",
        align: "left text-truncate hd-resize area-name text-center",
        sortable: false,
        value: "note"
      },
      {
        width: "120px",
        text: "",
        align: "left",
        sortable: false,
        value: "actions"
      }
    ];

    this.settingTaskHeaders = [
      {
        align: "center",
        value: "name",
        text: this.$t('area.area_name')
      },
      {
        align: "center",
        value: "action",
        text: this.$t('market.action'),
        width: "180px"
      },
      {
        align: "center",
        value: "previousAccountingProduct",
        text: this.$t('payment.original_list')
      },
      {
        align: "center",
        value: "currentAccountingProduct",
        text: this.$t('payment.new_list')
      },
      {
        align: "center",
        value: "previousPrice",
        text: this.$t('payment.original_price')
      },
      {
        align: "center",
        value: "currentPrice",
        text: this.$t('payment.new_price')
      },
      {
        align: "center",
        value: "previousOriginalDiscount",
        text: this.$t('payment.original_discount')
      },
      {
        align: "center",
        value: "currentOriginalDiscount",
        text: this.$t('payment.new_discount')
      },
      {
        align: "right",
        value: "diffPrice",
        text: ""
      },
      {
        align: "center",
        value: "previousType",
        text: this.$t('payment.original_method')
      },
      {
        align: "center",
        value: "currentType",
        text: this.$t('payment.new_method')
      },
      {
        align: "center",
        value: "createdBy",
        text: this.$t('created_by')
      },
      {
        align: "center",
        value: "createdAt",
        text: this.$t('created_at')
      },
      {
        align: "center",
        value: "updatedBy",
        text: this.$t('change_status_by')
      },
      {
        align: "center",
        value: "updatedAt",
        text: this.$t('change_status_at')
      },
      {
        align: "center",
        value: "status",
        text: this.$t('status')
      },
      {
        width: "200px",
        align: "center text-truncate hd-resize area-name text-center",
        value: "note",
        text: this.$t('note')
      }
    ];
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    marketId() {
      return this.$route.params.marketId;
    },
    ...mapGetters({
      approveTaskSettingHistory: "approveTask/approveTaskSettingHistory",
      marketName: "markets/getMarketName"
    })
  },

  methods: {
    onSearch() {
      this.$emit("onSearch", {
        startDate: this.$moment(this.startDate, "YYYY-MM-DD")
          .startOf("day")
          .toDate(),
        endDate: this.$moment(this.endDate, "YYYY-MM-DD")
          .endOf("day")
          .toDate()
      });
    },
    onClickDetail(approveTask) {
      this.currentSettingTasks = [];
      this.currentApproveTask = approveTask;
      if (approveTask.settingTasks && approveTask.settingTasks.length) {
        this.currentSettingTasks = approveTask.settingTasks;
        this.currentSettingTasks.forEach(task => {
          task.note = this.currentApproveTask.note || '-';
          task.cancelledNote = this.currentApproveTask.cancelledNote || '-';
        });
      }
      this.isDetail = true;
    },
    exportSettingTask() {
      try {
        ExportSettingTask.exportSettingTaskByMarket(this.currentSettingTasks);
      } catch (error) {
        this.isError = true;
      }
    }
  }
};
</script>

<style scoped>

.data-table-approvetask::v-deep th {
  padding: 0 !important;
}

.data-table-approvetask::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 10px;
    top: 15px;
  }
}

.data-table-approvetask::v-deep td {
  padding: 0 10px !important;
  max-width: 280px;
}

.data-table-approvetask::v-deep td.hd-resize {
  max-width: 200px;
}

</style>